/*********************** Custom JS for Boost AI Search & Discovery  ************************/
console.log('boost check js');
function checkOptionStatus(variants, optionValue) {
    console.log(variants, optionValue)
    for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        const variantOptions = variant.original_merged_options.filter(function(e) { 
            return e == 'colour:' + optionValue || e == 'color:' + optionValue || e == 'size:' + optionValue; 
        });
        console.log('variantOptions: ', variantOptions, variant.available);
        if (typeof variantOptions[0] !== 'undefined' && variant.available) {
            return true;
        }
    }
    return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Customize swatches',
            enabled: true,
            apply: () => ({
                props(props, element) {
                    return props;
                },
                afterRender(element) {
                    try {
                        const swatchOptions = element?.getParams()?.props?.options;
                        const productData =
                            componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                            componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
                      
                        if (swatchOptions?.length && productData) {
                            const productVariants = productData.variants || [];
                            let productId = productData.id;
                            if (productData?.split_product) {
                                productId = productData.variant_id;
                            }
                            let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                            
                            swatchOptions.forEach((option) => {
                                const optionValue = option.value;
                                option.available = checkOptionStatus(productVariants, optionValue);
                                if (!option.available) {
                                    const swatchOption = productItem.querySelector(`input[value="${optionValue}"]`);
                                    console.log(swatchOption);
                                    if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                                        swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                                    }
                                }
                            });
                        }
                    } catch (error) {
                        console.warn(error)
                    }
                }
            })
        });
    }
]);